<template>

    <div class="card-exchange" v-if="getExchange.base != getExchange.currency">
        <i class="icons-hand-holding-circle-dollar font-18"></i>
        <p class="mb-0 font-14">
            {{ __('checkout.note_charge', [ getExchange.base, getExchange.currency ]) }}  <br>
            <strong v-if="!source?.includes('trivago') && !source?.includes('google-hotel-ads')">
                {{ __('checkout.pay_will_be') }}
                <currency-display :amount="getQuote.quote.totalRate.totalAmount" :showCurrencyCode="true" :applyDecimals="true" :currencyCode="getExchange.base" :applyConvertion="false" :applySymbol="true"></currency-display>.
            </strong>
            <strong v-if="source?.includes('trivago') || source?.includes('google')">
                {{ __('checkout.pay_will_be_meta') }}
                {{getExchange.base}}.
            </strong>
        </p>
    </div>
</template>

<script>
    import { storeToRefs } from 'pinia';
    import { useCheckoutStore } from "../../stores/checkout";
    import { useExchangeRateStore } from "../../stores/exchange";


    export default {
        props: {
            source: ""
        },
        data() {
            return { };
        },
        setup() {
            const exchangeStore = useExchangeRateStore();
            const checkoutStore = useCheckoutStore();

            const { getQuote } = storeToRefs(checkoutStore);
            const { getExchange } = storeToRefs(exchangeStore);

            return {
                getQuote, getExchange
            }
        },
        async mounted() {
        },
        methods: {

        },
        components: {

        }
    }
</script>

<style>
    .card-exchange {
        padding: 20px 16px;
        display: flex;
        gap: 12px;
        border-radius: 0 0 4px 4px;
        border: 1px solid var(--border-subtle);
        border-top: none;
        background-color: var(--bg-base);
    }

</style>
